import Footer from "ui/snippets/footer/Footer";
import TopRow from "ui/snippets/topBar/TopBar";

import Container from "./Container";
import Content from "./Content";
import MainArea from "./MainArea";
import MainColumn from "./MainColumn";
import NavBar from "./NavBar";
import Root from "./Root";
import SideBar from "./SideBar";

export {
  Root,
  Container,
  Content,
  MainArea,
  SideBar,
  NavBar,
  MainColumn,
  Footer,
  TopRow,
};

// Root
//  Container
//    TopRow
//    MainArea
//       SideBar
//       MainColumn
//          Content
//    Footer
